export const CONFUSED_PREFIX = "confused/";
export const STORAGE_EVENT = "STORAGE_EVENT";

const constants = {
  CONFUSED_PREFIX,
  STORAGE_EVENT,
};

export default constants;
